var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "AddDates",

    getDefaultProps () {
        return {"width":"17px","height":"17px","viewBox":"0 0 17 17","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>39CDB1D7-DF5B-424E-9D3A-0D21FDBBF02A</title>
  <desc>Created with sketchtool.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Header-01-EventGroup" transform="translate(-250.000000, -271.000000)">
      <g id="Tabs" transform="translate(240.000000, 259.000000)">
        <g id="plus">
          <g transform="translate(10.000000, 12.000000)">
            <g id="Group-15">
              <path d="M8,8 L8,4.5 L8,4 L9,4 L9,4.5 L9,8 L12.5,8 L13,8 L13,9 L12.5,9 L9,9 L9,12.5 L9,13 L8,13 L8,12.5 L8,9 L4.5,9 L4,9 L4,8 L4.5,8 L8,8 Z" id="Combined-Shape" fill="currentColor"/>
              <path d="M17,8.5 C17,3.80557963 13.1944204,0 8.5,0 C3.80557963,0 0,3.80557963 0,8.5 C0,13.1944204 3.80557963,17 8.5,17 C13.1944204,17 17,13.1944204 17,8.5 Z M1,8.5 C1,4.35786438 4.35786438,1 8.5,1 C12.6421356,1 16,4.35786438 16,8.5 C16,12.6421356 12.6421356,16 8.5,16 C4.35786438,16 1,12.6421356 1,8.5 Z" id="Oval-1" fill="currentColor"/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/add-dates.svg
 **/